










import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  components: {
    SmText: () => import('@/components/atoms/SmText.vue'),
  }
})
export default class SmPrintLabel extends Vue {
  @Prop({ required: true })
  private readonly label!:string
}
